import Modal from './Modal'
import BaseModal from './BaseModal'
import CardModal from './CardModal'
import ImageModal from './ImageModal'

export {
  Modal,
  BaseModal,
  CardModal,
  ImageModal
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-bulma-modal/src/index.js
// module id = 31
// module chunks = 0